import { cx } from '@linaria/atomic';
import { stepBody } from '../../multi-step.styles';

export type StepBodyProps = { className?: string; children: React.ReactNode };

export function StepBody({ className, children }: StepBodyProps) {
  return <div className={cx(stepBody, 'step__body', className)}>{children}</div>;
}
